import { toStringWithCommas } from "@/utils/strings/number"

// 抽選キャンペーン (LOTTERY) の賞品の見せ方.
// 賞品は現金ではなく「ポイント」で、全員ではなく「抽選で」当たる.
// 「10 万円が当たる」と書くと現金がもらえると誤解されるので、
// 画面に賞品を出すときは必ずここの文言を通すこと (2026-09-29 定例の決定).

// 例: 100000 → "100,000円分のポイント"
export const lotteryPrizeText = (price: number): string =>
	`${toStringWithCommas(price)}円分のポイント`

// 賞品のポイントをお渡しするギフトの名称.
export const LOTTERY_PRIZE_GIFT_NAME = "えらべるマネー"

// 当選者の人数. 画面で「N 名様に当たる」と出すための値.
// 当選者の選定は画面の外で行うため、人数を変える時は選定側の運用と合わせて変えること.
export const LOTTERY_WINNER_COUNT = 12

// キャンペーン名. バナーの一番上に出す固定の名称.
export const LOTTERY_CAMPAIGN_NAME = "お客様感謝キャンペーン"
